<script>
export default {
  name: "IconWhitePhone"
};
</script>

<template>
  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.47 15.97a7.47 7.47 0
01-3.18-1.22c-1.1-.73-2.1-1.57-3-2.5-1.1-1.12-2.22-2.23-3.2-3.46-.76-1-1.44-2.04-1.82-3.23A4.12 4.12
0 011.48.86c.3-.26.62-.48.97-.67.41-.26.95-.25 1.35.02a4.7 4.7 0 012.08
2.37c.14.28.1.61-.1.86l-.73.92c-.21.27-.44.54-.63.83-.2.27-.2.63.01.9.48.64.95 1.3 1.47 1.9a24.87
24.87 0 003.12 3.08c.25.2.52.39.79.58.23.17.55.2.82.07l.84-.45 1.11-.69c.31-.19.71-.2 1.03-.02a4.89
4.89 0 012.22 2.08c.28.46.23 1.04-.12 1.45a4.68 4.68 0 01-4.24 1.88z"
      fill="#FFF"
      fill-rule="nonzero"
    />
  </svg>
</template>
